import { LinearGradient } from 'expo-linear-gradient';
import React, { useEffect, useState } from 'react';
import { FlatList, ScrollView, View } from "react-native"
import { useDispatch, useSelector } from 'react-redux';
import Colors from "../../constants/Colorsv2"
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { analytics_getCategories } from '../../store/actionsv1/analytics';
import { CategoryProps, LeaderProps, TimerangeProps } from '../../store/types/analytics_svc';
import { PublicPlayerProps } from '../../store/types/auth_svc';
import LeaderboardCard, { LeaderCard } from './components/LeaderboardCard';


const LeaderboardScreen = ({ route, navigation }:any) => {

    const [ leaderboard_state, setLeaderboardState ] = useState({
        category_id:route.params.category_id??'1',
        timerange_id:route.params.timerange_id??'1',
    })
    const { category_id, timerange_id } = leaderboard_state;

    const dispatch = useDispatch();
    
    const player:PublicPlayerProps|undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const categories:CategoryProps[] = useSelector((state:any) => state.analytics.stored_categories, (left, right) => left.length == right.length)
    const my_leader = useSelector((state:any) => state.analytics.leaders.find(l => l.player_id == player?.player_id && l.timerange_id == leaderboard_state.timerange_id && l.category_id == leaderboard_state.category_id), (left, right) => left?.category_score == right?.category_score)
    const category = categories.find(c => c.category_id == category_id)
    const timeranges: TimerangeProps[] = useSelector((state:any) => state.analytics.stored_timeranges, (left, right) => left.length == right.length)
    const timerange = timeranges.find(t => t.timerange_id == timerange_id)

    

    useEffect(() => {
        dispatch(analytics_getCategories())
    },[])

    const renderCategories = (data: {item:CategoryProps, index:number}) => {
        const active = category_id == data.item.category_id ? true : false
        return (
            <CategoryLozenge active={active} category={data.item} onSelect={(category) => setLeaderboardState({ ...leaderboard_state, category_id:category.category_id })}/>
        )
    }

    const renderTimeRanges = (data: {item:TimerangeProps, index:number}) => {
        const active = timerange_id == data.item.timerange_id ? true : false
        return (
            <TimerangeLozenge active={active} time_range={data.item} onSelect={(time_range) => setLeaderboardState({ ...leaderboard_state, timerange_id:time_range.timerange_id })}/>
        )
    }

    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <ScrollView style={{ flex:1 }}>
                {player ?
                <View nativeID='my_position'>
                    <LinearGradient colors={[Colors.brand.midnight, Colors.brand.midnightTopGradient]} style={{ paddingBottom:10 }}>
                    <View style={{flex:1, flexDirection:'row', alignItems:'center', padding:16}}>
                        <View style={{flex:2/10}} />
                        <View style={{flex:6/10, justifyContent:'center', alignItems:'center'}}>
                            <Text size={20} color={Colors.shades.white} weight='bold' textAlign='center'>My Position</Text>
                        </View>
                    </View>
                    {my_leader && category ?
                    <LeaderCard leader={my_leader} category={category} player={player} onSelect={(leader) => navigation.navigate('SocialStack', { screen:'SocialProfile', initial:false, params: { player_id:leader.player_id } })}/>
                    :<></>}
                </LinearGradient>
                </View>
                :<></>}
                <View nativeID='categories' style={{ padding:5, backgroundColor:Colors.shades.shade100 }}>
                    <FlatList data={categories} renderItem={renderCategories} keyExtractor={(item) => item.category_id.toString()} horizontal/>
                </View>
                <View nativeID='timeranges' style={{ padding:5, backgroundColor:Colors.shades.shade100 }}>
                    <FlatList data={timeranges} renderItem={renderTimeRanges} keyExtractor={(item) => item.timerange_id.toString()} horizontal/>
                </View>
                <LeaderboardCard category_id={category_id} timerange_id={timerange_id} viewer_id={player?.player_id} onLeaderSelect={(leader) => navigation.navigate('SocialStack', { screen:'SocialProfile', initial:false, params: { player_id:leader.player_id } })}/>
            </ScrollView>
        </View>
    )

}

export default LeaderboardScreen


type CategoryLozengeProps = {
    category:CategoryProps,
    active?:boolean,
    onSelect: (category:CategoryProps) => void
}
const CategoryLozenge = ({ category, active, onSelect }:CategoryLozengeProps) => {
    
    const handleSelect = () => {
        if(!onSelect){ return }
        return onSelect(category)
    }

    return (
        <TouchableOpacity style={{ margin:4, borderWidth:1, borderColor:Colors.shades.shade400, backgroundColor:active?Colors.brand.midnight:Colors.shades.white, borderRadius:100, padding:10, paddingRight:20, paddingLeft:20 }} onPress={() => handleSelect()}>
            <Text size={16} color={active?Colors.shades.white:Colors.brand.midnight} weight='semibold'>{category.name}</Text>
        </TouchableOpacity>
    )
}


type TimerangeLozengeProps = {
    time_range:TimerangeProps,
    active?:boolean,
    onSelect: (time_range:TimerangeProps) => void
}
const TimerangeLozenge = ({ time_range, active, onSelect }:TimerangeLozengeProps) => {
    
    const handleSelect = () => {
        if(!onSelect){ return }
        return onSelect(time_range)
    }

    return (
        <TouchableOpacity style={{ margin:4, borderWidth:1, borderColor:Colors.shades.shade400, backgroundColor:active?Colors.brand.midnight:Colors.shades.white, borderRadius:100, padding:10, paddingRight:20, paddingLeft:20 }} onPress={() => handleSelect()}>
            <Text size={16} color={active?Colors.shades.white:Colors.brand.midnight} weight='semibold'>{time_range.name}</Text>
        </TouchableOpacity>
    )
}